import versionManifest from "../../version.json";

export const buildInfo = Object.freeze({
  version: versionManifest.version,
  clientContractVersion: versionManifest.clientContractVersion,
  localSchemaVersion: versionManifest.localSchemaVersion,
  commitSha: __DISCUS_BUILD_SHA__,
  buildTime: __DISCUS_BUILD_TIME__,
});
